import { FormControl } from '@angular/forms';
import * as _ from 'lodash';

export const NoWhitespaceValidator = (control: FormControl) => {
  if (control.value && _.trim(control.value).length === 0) {
    return { whitespace: true };
  }
  return null;
};
